import { render } from "./audit_logs.vue?vue&type=template&id=df244908"
import script from "./audit_logs.vue?vue&type=script&lang=js"
export * from "./audit_logs.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\EZELINK\\Wajiha\\Projects\\EzenmsV2_vueApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__